import React from 'react'
// import Alert from '@material-ui/lab/Alert'
import type { AlertProps } from '@material-ui/lab/Alert'
import { useQueryNotifications } from '../common'
// import { useQueryNotifications, useMutationReadNotification } from '../common'
import { components } from '../../../generated'

type NotificationBannerProps = AlertProps & {
  service: components['schemas']['AlertServiceType']
}

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
  service
  // ...props
}) => {
  const { data: notifications } = useQueryNotifications(service, {
    select: (notifications) =>
      notifications.filter(
        (notification) => notification.type === 'header' && !notification.isRead
      )
  })

  // const readNotificationMutation = useMutationReadNotification()

  if (!notifications?.length) {
    return null
  }

  return (
    <>
      {/* {notifications.map((notification) => (
        <Alert
          key={notification.id}
          variant="filled"
          severity="warning"
          style={{
            width: '100%'
          }}
          {...props}
          onClose={() => {
            if (notification.id) {
              readNotificationMutation.mutate({
                type: service,
                notificationId: notification.id
              })
            }
          }}
        >
          {notification.text}
        </Alert>
      ))} */}
    </>
  )
}
